import React, { useEffect, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import BarSeriesChart from './components/BarSeriesChart'
import { SingleSeriesChart } from './components/SeriesChart'
import { getAnalyticsErrorMessage } from './utils'

const Maintenance = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getMaintenance(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    return (
        <AnalyticsPageShell title='Análises de negócio — Manutenção' loading={loading} error={error} showWorkshopId>
            <MetricsSection title='Atividade no período (eventos)' metrics={data?.activity} />
            <BarSeriesChart title='Principais tipos de atividade' points={data?.topActivityTypes} color='#00bfa9' />
            <SingleSeriesChart title='Manutenções ao longo do tempo' points={data?.overTime} dataKey='manutenções' />
            <InsightsPanel insights={data?.insights} />
        </AnalyticsPageShell>
    )
}

export default Maintenance
